// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608110041/js/" + chunkId + "." + {"44":"12bd2bf1","225":"e6f205dd","481":"10b91763","486":"8a0653cb","770":"418c7655"}[chunkId] + ".0.9588935962560768.chunk.js";
};